//import Chat from "./Chat/Chat.old";
import "./MainPage.css";
import Layout from "./Layout/Layout";
import Course from "./CourseHeader/Course";
import { useState,useEffect } from "react";
import { authProps } from "../../App";
import {cancelOngoingOperations} from "./Chat/utilsLogic/utils";
import { v4 } from 'uuid';
import {closeArrowHoverBtn, toggleFlatBtn, openArrowHoverBtn} from "../../utils";
import {fetchInitQuestions} from "../../services/messageService";
import {logDebug} from "../../utils/logger";
import ChatUI from "./Chat/ChatUI";
import {useAppContext} from "../../AppDataContext";
import {sendStatistics} from "../../services/dataColectorService";



export interface Message {
  type: "user" | "bot" | "bot initial-questions";  // Define the allowed types for `type`
  text: string;
  id:number;
}

function ChatContext(props: {
    policiesNotAllow: boolean,
    setVersions: (value: (((prevState: boolean) => boolean) | boolean)) => void,
    userId: string,
    client_id: string,
    client_token: string,
    messages: Message[],
    setMessages: (value: (((prevState: Message[]) => Message[]) | Message[])) => void,
    startNewChat: () => Promise<void>,
    badgeurl: string | undefined,
    article_index: string | undefined,
    welcome_message: any,
    follow_up_question: string | undefined,
    proxy: string | undefined
}) {
    return null;
}

export const MainPage: React.FC<authProps> = ({
  // userId,
  // logourl,
  // badgeurl,
  // should_present_legal_banner,
  // client_id,
  // client_token,
  // article_index,
  // follow_up_question,
  // proxy,
  // welcome_message,
}) => {
    const dataContext = useAppContext();
  const [collapsed, setCollapsed] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [menuHovered, setMenuHovered] = useState(false);
  const [policiesNotAllow, setPoliciesNotAllow] = useState(dataContext.should_present_legal_banner);
  const [messages, setMessages] = useState<Message[]>([]);
  const [manualCollapse, setManualCollapse] = useState(false);
  const [renderKey, setRenderKey] = useState(0);
  const [newChatStarted, setNewChatStarted] = useState(false);
const [isNavVisible, setIsNavVisible] = useState(false);

  let AppDataContext = useAppContext(); // Use the context hook to get the context value
  const handleToggle = (newState?: boolean) => {
    setCollapsed(newState !== undefined ? newState : !collapsed);
    setHovered(false);
    setMenuHovered(false);
  };

  const startNewChat = async () => {
    const oldSessionId = sessionStorage.getItem("session_ID");
    sessionStorage.setItem("session_ID", v4().substring(0, 8));
    await cancelOngoingOperations(true);
    setMessages([]); // Clear messages
    // Fetch questions and set them as the first message
    const startQuestionsText: any = await fetchInitQuestions(dataContext.proxy, dataContext.client_token, dataContext.client_id, dataContext.userId,null,AppDataContext.language_for_chat,null,null,null);
   AppDataContext.prompt_type = "STARTER";
   AppDataContext.actionDataContextProps = null;
   AppDataContext.ActionList = undefined;
    AppDataContext.follow_up_question = undefined;
   AppDataContext.article_index = undefined;
   AppDataContext.asset_symbol = undefined;
    AppDataContext.asset_type = undefined;
    setMessages([startQuestionsText]); // Set the initial messages
    setRenderKey((prevKey) => prevKey + 1); // Increment the render key
      handleToggle(true);
    sendStatistics(dataContext.proxy, dataContext.client_id, dataContext.userId, dataContext.client_token, { 'NEW_CHAT_CLICKED': 1 }, false, 0,
        "end_of_session", oldSessionId);
    logDebug("new chat started");
  };

    useEffect(() => {
    if (newChatStarted) {
      setNewChatStarted(false);
    }
  }, [newChatStarted]);

  useEffect(() => {

    const handleResize = () => {
      if (!collapsed) {
        if (window.innerWidth <= 1100) {
          setCollapsed(true);
        } else {
          setCollapsed(false);
        }
      }
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [manualCollapse]);

  return (
    <>
      <div className="ellipseTop"></div>
      <div className="ellipseBottom"></div>
      <div className="boxingchat">
        <div
          className={`main ${collapsed ? "collapsed" : ""}`}
          onMouseEnter={() => setMenuHovered(true)}
          onMouseLeave={() => setMenuHovered(false)}
        >
          <Layout
            logourl={dataContext.logourl}
            startNewChat={startNewChat}
            collapsed={collapsed}
            handleToggle={handleToggle}
          />
          <div className="content">
            <div
              className={`toggle-button ${collapsed ? "collapsed" : ""}`}
              onClick={() => handleToggle()}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              data-hover-text={collapsed ? "Open Sidebar" : "Close Sidebar"}
            >
              {collapsed ? (
                <img
                  src={hovered || menuHovered ? openArrowHoverBtn : toggleFlatBtn}
                  alt="Open Sidebar"
                />
              ) : (
                <>
                  <img
                    src={hovered || menuHovered ? closeArrowHoverBtn : toggleFlatBtn}
                    alt="Close Sidebar"
                  />
                </>
              )}
            </div>
            <div
              className={`gpt ${collapsed ? "collapsed" : ""}`}
              onMouseEnter={() => setMenuHovered(false)}
            >
              <section className="course_wrapper">
                <Course />
              </section>
              <ChatUI
                key={renderKey} // Force re-render by changing the key
                policiesNotAllow={policiesNotAllow}
                setVersions={setPoliciesNotAllow}
                userId={dataContext.userId}
                userClass={dataContext.userClass}
                client_id={dataContext.client_id}
                client_token={dataContext.client_token}
                messages={messages}
                setMessages={setMessages}
                startNewChat={startNewChat}
                badgeurl={dataContext.badgeurl}
                article_index={dataContext.article_index}
                welcome_message={dataContext.welcome_message}
                follow_up_question={dataContext.follow_up_question}
                proxy={dataContext.proxy}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
